import React from 'react';
import { useSelector } from 'react-redux';
import { isLiscenseLoading } from 'redux/auth/authSlice';
import './loader.style.css';

export function AppLoader() {
    const { isLoading } = useSelector(state => state.shared);
    const liscenseLoading = useSelector(isLiscenseLoading);

    if (!isLoading || liscenseLoading) {
        return null;
    }

    return (
        <div className="loader-container">
            <div className="lds-spinner">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
            </div>
        </div>
    );
}
